import {
  clickStreamUser,
  convertTimeInHourAndMin,
  getPriceInfoForEntity,
  SessionKeys,
} from "../../../utils/AppUtils";
import Page from "../../Page";
import PartnerListSection from "./PartnerListSection";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  providerList,
  providerListClear,
} from "../../../redux/provider/actions";
import { useDispatch, useSelector } from "react-redux";
import CONFIG from "../../../utils/config";
import { getActiveHeader } from "../../../redux/home/actions";
import CourseListLearnComp from "../../b2cComponents/CourseListLearnComp";
import VideoListingSectionComponent from "../ListingContent/VideoListingContent/VideoListingSectionComponent";
import CoachingListSectionParent from "../Coaching/CoachingListSectionParent";
import CertificationListSection from "../../Certification/CertificationListSection";
import EventListSectionForPartner from "../Event/EventListSectionForPartner";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import LPListLearnComp from "../../b2cComponents/LPListLearnComp";

const PartnerListPage = ({ type }) => {
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const c = params.get("c");
  let allProviders = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    allProviders = paramsReq.allProviders;
  }

  const [selectedTab, setselectedTab] = useState("");
  useEffect(() => {
    if (tab === "1") {
      setselectedTab("courses");
    } else if (tab === "2") {
      setselectedTab("videos");
    } else if (tab === "3") {
      setselectedTab("events");
    } else if (tab === "4") {
      setselectedTab("certifications");
    } else if (tab === "5") {
      setselectedTab("coaching");
    } else if (tab === "6") {
      setselectedTab("lp");
    } else {
      setselectedTab("");
    }
  }, [tab]);

  useEffect(() => {
    dispatch(getActiveHeader("our-partners"));
    window.scrollTo(0, 0);
  }, []);

  const providersDataResponse = useSelector(
    (state) => state.provider.providersDataListRes
  );
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

  const [partnersList, setPartnersList] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  useEffect(() => {
    setPartnersList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);
  const [originalPartnersList, setOriginalPartnersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSort, setSelectedSort] = useState(1);

  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  const closeMenu = () => {
    setIsOpenMenu(false);
  };

  const [routes, setRoutes] = useState([
    { value: "courses", label: "Courses", id: "idCoursesMenu" },
    { value: "videos", label: "Videos", id: "idVideosMenu" },
    {
      value: "learningpath",
      label: "Action Paths",
      id: "idLearningPathsMenu",
    },
  ]);
  const routeTo = (value) => {
    let paramsReq = {
      allPartners: true,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    switch (value) {
      case "courses":
        clickStreamUser("clicked", { route: "courses" });
        navigate(`/our-partners/courses?tab=1&c=${encodedUrl}`);
        return;
      case "videos":
        clickStreamUser("clicked", { route: "videos" });
        navigate(`/our-partners/videos?tab=2&c=${encodedUrl}`);
        return;
      case "events":
        clickStreamUser("clicked", { route: "events" });
        navigate(`/our-partners/events?tab=3&c=${encodedUrl}`);
        return;
      case "certifications":
        clickStreamUser("clicked", { route: "certifications" });
        navigate(`/our-partners/certifications?tab=4&c=${encodedUrl}`);
        return;
      case "coaching":
        clickStreamUser("clicked", { route: "coaching" });
        navigate(`/our-partners/coaching?tab=5&c=${encodedUrl}`);
        return;
      case "lp":
        clickStreamUser("clicked", { route: "lp" });
        navigate(`/our-partners/learningpath?tab=6&c=${encodedUrl}`);
        return;
      default:
        let paramsReq1 = {
          allProviders: true,
        };
        let jsonString1 = JSON.stringify(paramsReq1);
        let encodedUrl1 = btoa(jsonString1);
        clickStreamUser("clicked", { route: "Partners" });
        navigate(`/our-partners?c=${encodedUrl1}`);
        return;
    }
  };

  const [searchText, setSearchText] = useState("");

  const provider_listing = () => {
    setIsLoading(true);
    setPartnersList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    dispatch(
      providerList({
        module: "providerList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort_by:
            selectedSort === 1 ? "ASC" : selectedSort === 2 ? "DESC" : "ASC",
          search: searchText,
          entity_type: tab === "1" ? "Courses" : "",
          is_coaching: tab === "1" ? true : false,
        },
      })
    );
  };

  const onSearchClicked = (searchText) => {
    setSearchText(searchText)
  }

  const [apiCalled, setApiCalled] = useState(true);
  useEffect(() => {
    setApiCalled(true);
    if(tab!="6"){provider_listing();}
    return () => {
      dispatch(providerListClear());
    };
  }, [dispatch, selectedSort, allProviders, type, searchText]);

  const navigateToView = (data) => {
    let paramsReq = {
      provider_id: data?.provider_id,
      provider_name: data?.display_name,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/partner-detail/?c=${encodedUrl}`;
    navigate(url);
  };

  const formatDataForProductCard = (partnersList) => {
    setPartnersList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    let eventArr = [];
    for (let item of partnersList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item.provider_img;
      for (let i of item.menu_data) {
        if (i === "learningpath") {
          tags.push("Action Path");
        } else {
          tags.push(i);
        }
      }
      let priceInfo = getPriceInfoForEntity({
        isUserPremiun: isPremiumUser,
        productType: item.product_type ? item.product_type.toLowerCase() : "",
        premiumPrice: item.product_premium_price
          ? item.product_premium_price
          : 0,
        basicPrice: item.product_basic_price ? item.product_basic_price : 0,
        offerPremiumPrice: 0,
        offerBasicPrice: 0,
        offerStartDate: "", //video.start_date_&_time_of_offer,
        offerEndDate: "", //video.end_date_&_time_of_offer,
        source: item.source,
        productIsPaid: false,
        inAddToCart: false,
      });

      console.log(priceInfo);

      let footerComp = "";

      eventArr.push({
        id: item?.provider_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: "partner",
        productOrigin: "xsel",
        title: item.display_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description ? item.description : "",
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: false,
        showLikeMenu: false,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToView(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }
    setPartnersList(eventArr);
    setOriginalPartnersList(eventArr);
  };

  useEffect(() => {
    if (
      !_.isEmpty(providersDataResponse) &&
      providersDataResponse?.status === "success"
    ) {
      let providerList = providersDataResponse.payload.payload?.list;
      let menu_data = providersDataResponse.payload.payload?.menus;
      console.log("menus", menu_data, window.location.href);
      if (!_.isEmpty(menu_data)) {
        const transformedRoutes = menu_data?.map((menu) => ({
          value:
            menu === "Courses"
              ? "courses"
              : menu === "Videos"
              ? "videos"
              : menu === "Coaching"
              ? "coaching"
              : menu === "Event"
              ? "events"
              : menu === "Certificate"
              ? "certifications"
              : menu === "learningpath"
              ? "lp"
              : _.trim(menu) === "Bundle" ? "bundle" :"",
          label:
            menu === "Courses"
              ? "Courses"
              : menu === "Videos"
              ? "Videos"
              : menu === "Coaching"
              ? "Coaching"
              : menu === "Event"
              ? "Events"
              : menu === "Certificate"
              ? "Certifications"
              : menu === "learningpath"
              ? "Action Path"
              : _.trim(menu) ==="Bundle" ? 
              "Combo & Offers": "",
        }));
        console.log("transformed routes---", transformedRoutes);
        // Update routes state
        setRoutes(transformedRoutes);
      } else {
        setRoutes([]);
      }
      if (!_.isEmpty(providerList)) {
        formatDataForProductCard(providerList);
      } else {
        setPartnersList([]);
      }
      setIsLoading(false);
    } else if (!apiCalled) {
      setPartnersList([]);
      setRoutes([]);
      setIsLoading([]);
    }
  }, [providersDataResponse]);

  const renderMainContent = () => {
    if (type) {
      switch (type) {
        case "courses":
          return <CourseListLearnComp />;
        case "videos":
          return <VideoListingSectionComponent />;
        case "event":
          return <EventListSectionForPartner />;
        case "certificate":
          return <CertificationListSection />;
        case "coaching":
          return <CoachingListSectionParent />;
        case "lp":
          return <LPListLearnComp />;
        case "all":
          return (
            <PartnerListSection
              eventList={partnersList}
              originalEventList={originalPartnersList}
              setEventList={setPartnersList}
              setSelectedSort={setSelectedSort}
              isLoading={isLoading}
              onSearchClicked={onSearchClicked}
            />
          );
        default:
          return "";
      }
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Page>
        <section class="bannersection">
          <div class="container mt-5">
            <div class="row justify-content-md-center">
              {!_.isEmpty(routes) && (
                <div class="col-12 col-xl-2 col-lg-2 col-md-3 leftmenusec">
                  <div
                    className="d-xl-none btn-filter-mob"
                    onClick={toggleMenu}
                  >
                    Menu
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <path
                        d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </div>
                  <ul className={`sidebar ${isOpenMenu ? "openMenu" : ""}`}>
                    <span
                      className="close-menu d-xl-none cursor-pointer"
                      onClick={toggleMenu}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M15.1484 13.5781C15.5703 14.0469 15.5703 14.75 15.1484 15.1719C14.6796 15.6406 13.9765 15.6406 13.5546 15.1719L8.02344 9.59375L2.44532 15.1719C1.97656 15.6406 1.27344 15.6406 0.851559 15.1719C0.382814 14.75 0.382814 14.0469 0.851559 13.5781L6.42969 8L0.851559 2.42188C0.382814 1.95312 0.382814 1.25 0.851559 0.828125C1.27344 0.359375 1.97656 0.359375 2.39844 0.828125L8.02344 6.45312L13.6015 0.875C14.0234 0.40625 14.7265 0.40625 15.1484 0.875C15.6172 1.29688 15.6172 2 15.1484 2.46875L9.57034 8L15.1484 13.5781Z"
                          fill="#2D2D2D"
                        />
                      </svg>
                    </span>
                    {isLoading
                      ? [1, 2, 3, 4].map((p, i) => {
                          return (
                            <div className="mb-4">
                              <ShimmerScreen
                                case={"rect"}
                                height="2rem"
                                width="100%"
                              />
                            </div>
                          );
                        })
                      : routes.map((r, i) => {
                          return !_.isEmpty(r) ? (
                            <li
                              id={r.id}
                              className={`${
                                selectedTab === r.value ? "activemenu" : ""
                              }`}
                              onClick={closeMenu}
                            >
                              <button
                                className="reset-btn cursor-pointer"
                                onClick={() => routeTo(r.value)}
                              >
                                {r.label}
                              </button>
                            </li>
                          ) : (
                            ""
                          );
                        })}
                  </ul>
                </div>
              )}
              <div
                class={`${
                  !_.isEmpty(routes)
                    ? " col-12 col-xl-10 col-lg-10 col-md-9"
                    : "col-12 col-xl-12 col-lg-12 col-md-12"
                }`}
              >
                {renderMainContent()}
              </div>
            </div>
          </div>
        </section>
      </Page>
    </>
  );
};
export default PartnerListPage;
